import { Injectable } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import { BehaviorSubject } from 'rxjs'
import { StructureSearchParams } from '../../app/models/structures-search-params'

@Injectable({
  providedIn: 'root',
})
export class StructureSearchParamsService {
  private _params$ = new BehaviorSubject<StructureSearchParams>(null)

  get params(): StructureSearchParams {
    return this._params$.value
  }

  params$ = this._params$.asObservable()

  constructor(private router: Router, route: ActivatedRoute) {
    const queryParams = route.snapshot.queryParams

    if (queryParams) {
      const params = {
        pageSize: queryParams.number,
        pageIndex: queryParams.number,
        isAsc: queryParams.boolean,
        sortBy: queryParams.string,
        jobName: queryParams.string,
        activeUser: queryParams.string,
        structureNumber: queryParams.string,
        city: queryParams.string,
        stateCode: queryParams.string,
        countryCode: queryParams.string,
        topMasterKeyName: queryParams.string,
        topMasterKeySection: queryParams.string,
        keyWayFamily: queryParams.string,
        combinatingRuleSetId: queryParams.combinatingRuleSetId,
        chamberCount: queryParams.number,
        orderNumber: queryParams.number,
        registerNumber: queryParams.string,
        combination: queryParams.string,
        keySection: queryParams.string,
        status: queryParams.number,
        keyName: queryParams.string,
        note: queryParams.string,
      }
      this._params$.next(params)
    }
  }

  next(params: StructureSearchParams, route: ActivatedRoute) {
    Object.keys(params).forEach((key) => {
      if (params[key] == '') {
        params[key] = undefined
      }
    })

    this._params$.next(params)
    this.router.navigate([], {
      relativeTo: route,
      queryParams: params,
      queryParamsHandling: 'merge',
    })
  }
}
